import { Headline } from '@almbrand/headline';
import { Modal } from '@almbrand/modal';
import { useAutoLogoutTimer } from 'hooks/useAutoLogoutTimer';
import { useAppSelector } from 'store/hooks';
import { removeStateFromCookie } from 'utilities/cookieUtils';
import { removeStateFromSessionStorage } from 'utilities/sessionStorageUtils';

export interface LeaveFlowModalProps {
	setModalOpen: (open: boolean) => void;
	triggerLogout: boolean;
	requestedUrl: string;
	isAutoLogout?: boolean;
	isResultPage?: boolean;
}

const DEFAULT_MODAL_TEXT = {
	title: 'Er du sikker på, at du vil annullere din anmeldelse?',
	content:
		'Hvis du annullerer din skade, skal du være opmærksom på, at du skal starte forfra når/hvis du anmelder skaden på et senere tidspunkt.',
	closeText: 'Færdiggør anmeldelse',
	actionText: 'Annuller anmeldelse',
};

const RESULT_PAGE_MODAL_TEXT = {
	title: 'Er du sikker på, at du vil forlade denne side?',
	content:
		'Du vil blive omdirigeret til vores forside og det bliver ikke muligt at vende retur til din skadeanmeldelse.',
	closeText: 'Bliv på side',
	actionText: 'Forlad side',
};

export const LeaveFlowModal: React.FC<LeaveFlowModalProps> = ({
	setModalOpen,
	triggerLogout,
	requestedUrl,
	isAutoLogout,
	isResultPage,
}) => {
	const claimContent = useAppSelector((state) => state.claimContent);
	const { applicationId } = claimContent?.wizardData?.mitIdConfig?.almbrand ?? {};
	const modalText = isResultPage ? RESULT_PAGE_MODAL_TEXT : DEFAULT_MODAL_TEXT;

	/**
	 * User want's to leave the claim flow, so delete current claim flow and redirect to main website.
	 */
	const logout = async () => {
		// FIXME: get the redirectUri from the cms
		const logoutUrl = `/auth/logout?applicationId=${applicationId}&redirectUri=${requestedUrl}`;
		removeStateFromSessionStorage();
		removeStateFromCookie();
		window.location.href = logoutUrl;
	};

	const handleLeaveFlow = () => {
		// FIXME: get the redirectUri from the cms

		if (triggerLogout) {
			logout();
		} else {
			window.location.href = requestedUrl;
		}
	};

	/**
	 * Handel auto logout if the usere have been inactive for to lognf
	 */
	const { triggerAutoLogout, triggerTimer } = useAutoLogoutTimer(60000); //1 min before auto logout

	if (isAutoLogout) {
		triggerTimer();
	}

	if (triggerAutoLogout) {
		logout();
	}
	/************************************************************ */

	return (
		<Modal
			closeButtonProps={{
				title: modalText.closeText,
				type: 'tertiary',
			}}
			actionButtonProps={{
				title: modalText.actionText,
				type: 'primary',
				onClick: handleLeaveFlow,
			}}
			ariaClose='Close'
			handleClose={() => setModalOpen(false)}
		>
			<>
				{/* TODO: change inline styling when we have proper design in Figma */}
				<div style={{ marginBottom: 'var(--spacing--md)' }}>
					<Headline
						title={modalText.title || ''}
						size={'default'}
						variant={'h2'}
					/>
				</div>
				{modalText.content}
			</>
		</Modal>
	);
};
